<script>
import ETicketForm from './form';

export default {
   name: 'CreateETicketFormModal',
   components: { ETicketForm },
   methods: {
      create() {
         this.$bvModal.show('createETicketFormModal')
      },
      closeModal() {
         this.$bvModal.hide('createETicketFormModal')
         this.$emit('closeModal');
      }
   }
}
</script>

<template>
   <b-modal id="createETicketFormModal" class="modal-xxl" centered hide-footer size="xl">
      <template #modal-header>
         <div ref="top">
            <h3>{{ $t('account-page-facility-my-page-e-ticket.index.create_modal_title') }}</h3>
         </div>
         <button type="button" class="close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
         </button>
      </template>
      <ETicketForm @close="closeModal" @scroll="$refs.top.scrollIntoView()"/>
   </b-modal>
</template>